package co.maytes.standupbot.dashboard.features.settings

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.components.feedback.ModalShell
import co.maytes.standupbot.dashboard.components.feedback.ModalSize
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.components.widgets.TextInputStyle
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.dom.Input

@Composable
fun LinkGithubIdentityModal(
    displayName: String,
    currentGithubLogin: String?,
    onSave: (githubLogin: String?) -> Unit,
    onDismiss: () -> Unit,
) {
    var value by remember { mutableStateOf(currentGithubLogin.orEmpty()) }

    ModalShell(onDismiss = onDismiss, size = ModalSize.Sm) {
        Column {
            SpanText(
                text = "Link GitHub identity",
                modifier = Modifier
                    .fontSize(Typography.h2.size)
                    .fontWeight(Typography.h2.weight)
                    .color(Palette.textPrimary)
                    .margin(bottom = Spacing.xs),
            )
            SpanText(
                text = "Enter the GitHub username for $displayName. Their standup will then pull from GitHub activity attributed to this account, across every standup they're a member of. Leave blank to clear.",
                modifier = Modifier
                    .fontSize(Typography.bodySmall.size)
                    .color(Palette.textSecondary)
                    .margin(bottom = Spacing.lg),
            )

            Column(modifier = Modifier.fillMaxWidth().margin(bottom = Spacing.lg)) {
                SpanText(
                    text = "GitHub username",
                    modifier = Modifier
                        .fontSize(Typography.caption.size)
                        .fontWeight(Typography.caption.weight)
                        .color(Palette.textTertiary)
                        .margin(bottom = Spacing.xxs)
                        .styleModifier {
                            property("text-transform", "none")
                            property("letter-spacing", "0.04em")
                        },
                )
                Input(
                    type = InputType.Text,
                    attrs = TextInputStyle.toModifier()
                        .fillMaxWidth()
                        .toAttrs {
                            value(value)
                            placeholder("github-username")
                            onInput { value = it.value }
                        },
                )
            }

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Row(horizontalArrangement = Arrangement.spacedBy(Spacing.sm)) {
                    Button(
                        label = "Cancel",
                        variant = ButtonVariant.Ghost,
                        onClick = onDismiss,
                    )
                    Button(
                        label = "Save",
                        variant = ButtonVariant.Primary,
                        onClick = { onSave(value.trim().ifEmpty { null }) },
                    )
                }
            }
        }
    }
}
